module.exports = __webpack_public_path__ + "img/changeconfig.e8ff0355.svg";